// frontend-customer/src/utils/vendorTime.js

export const getVendorTimezone = (country) => {
    const c = (country || 'India').toLowerCase();

    if (c.includes('us') || c.includes('united states')) {
        return 'America/New_York';
    }

    if (c.includes('canada') || c === 'ca') {
        return 'America/Toronto';
    }

    if (c.includes('uk') || c === 'gb') {
        return 'Europe/London';
    }

    if (c.includes('uae') || c.includes('emirates')) {
        return 'Asia/Dubai';
    }

    return 'Asia/Kolkata';
};

export const getVendorLocalTime = (country) => {
    const timezone = getVendorTimezone(country);
    const now = new Date();

    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        weekday: 'long',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).formatToParts(now);

    const getPart = (type) => {
        const part = parts.find(p => p.type === type);
        return part ? part.value : '';
    };

    let hour = parseInt(getPart('hour'), 10);

    // Intl can return 24 for midnight in some environments.
    if (hour === 24) {
        hour = 0;
    }

    return {
        year: parseInt(getPart('year'), 10),
        month: parseInt(getPart('month'), 10),
        day: parseInt(getPart('day'), 10),
        hour,
        minute: parseInt(getPart('minute'), 10),
        weekday: getPart('weekday')
    };
};